export const environment = {
    
    server_url: 'https://stage.northernarc.com/retail/dev/api/',
    api_key:'Q1ZYYjkzUEpOV2FwbVF0TE8=',
      
    allEnvironmentUrls: [
      {
        name: "Dev",
        url: "https://stage.northernarc.com/retail/dev/api/"
      },
      {
        name: "QA",
        url: "https://stage.northernarc.com/retail/api/"
      },
      {
        name: "Prod",
        url: "https://nimbus.northernarc.com/eo/api/"
      
      }
    ]
  };
 